//frontend/src/context/BookingContext.js
import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
const BookingContext = createContext();
export const BookingProvider = ({ children }) => {
const [bookingData, setBookingData] = useState({
service: null,
specialist: null,
dateTime: null,
clientInfo: {
name: '',
phone: '',
email: '',
telegram: '',
instagram: ''
}
});

const [activeStep, setActiveStep] = useState(0);
const navigate = useNavigate();

const routes = {
    service: '/select-service',
    specialist: '/select-specialist',
    datetime: '/select-datetime',
    confirmation: '/confirmation'
};

const steps = [
    { key: 'service', label: 'Select Service', path: '/select-service' },
    { key: 'specialist', label: 'Select Specialist', path: '/select-specialist' },
    { key: 'datetime', label: 'Select Date & Time', path: '/select-datetime' },
    { key: 'confirmation', label: 'Personal Information', path: '/confirmation' }
];

const updateBookingStep = (step, data) => {
    setBookingData(prev => ({
        ...prev,
        [step]: data
    }));
};

const canNavigateToStep = (stepKey) => {
    const stepIndex = steps.findIndex(s => s.key === stepKey);
    
    if (stepKey === 'confirmation') {
        return bookingData.service && bookingData.specialist && bookingData.dateTime;
    }
    
    return true;
};

const navigateToStep = (stepKey) => {
    if (canNavigateToStep(stepKey)) {
        const step = steps.find(s => s.key === stepKey);
        if (step) {
            navigate(step.path);
        }
    }
};

const goBack = () => {
    navigate(-1);
};

const resetBooking = () => {
    setBookingData({
        service: null,
        specialist: null,
        dateTime: null,
        clientInfo: {
            name: '',
            phone: '',
            email: '',
            telegram: '',
            instagram: ''
        }
    });
    setActiveStep(0);
};

const calculateActiveStep = (path) => {
    const currentStepIndex = steps.findIndex(step => step.path === path);
    if (currentStepIndex !== -1) {
        setActiveStep(currentStepIndex);
    }
};

return (
    <BookingContext.Provider value={{
        bookingData,
        setBookingData,
        activeStep,
        setActiveStep,
        steps,
        updateBookingStep,
        canNavigateToStep,
        navigateToStep,
        resetBooking,
        calculateActiveStep,
        goBack,
        routes
    }}>
        {children}
    </BookingContext.Provider>
);

};
export const useBooking = () => useContext(BookingContext);
export default BookingContext;